import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "description-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "zoom-toolbar" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "zoom-label" }
const _hoisted_7 = { style: {"width":"100%"} }

import { ref, onBeforeMount, computed, toRefs } from "vue";
import { IonContent, IonPage, IonButton, modalController } from "@ionic/vue";

import PopUpMask from "@/modules/a.worksheets/views/components/feedback/PopUpMask.vue";
import MilageInput from "@/globals/components/MilageInput.vue";
import ErrorMsg from "@/globals/components/ErrorMsg.vue";

import { getFont, IFont } from "@/helpers/fonts";
import { useDeviceStatus } from "@/stores/deviceStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'InsertUrlVideo',
  props: {
    initialUrl: {},
    iconSrc: {},
    labels: {}
  },
  setup(__props: any) {

const props = __props;

const { isWeb } = toRefs(useDeviceStatus());

const icon = ref<string>("");
const titleFontStyle = ref<IFont>();

const videoUrl = ref<string>(props.initialUrl ?? "");
const isWarning = ref(false);



const widthPercent = ref<number>(80);


function onWidthInput(e: Event) {
    const el = e.target as HTMLInputElement;
    const raw = Number(el.value);

    const snapped = Math.round(raw / 10) * 10;

    const clamped = Math.min(100, Math.max(20, snapped));

    widthPercent.value = clamped;

    el.value = String(clamped);
}

const labels = computed(() => ({
    title: props.labels?.title ?? "Inserir vídeo",
    lines: props.labels?.lines ?? [
        "Cola o link do vídeo (YouTube, Vimeo, etc.).",
    ],
    videoLabel: props.labels?.videoLabel ?? "Vídeo",
    videoPlaceholder: props.labels?.videoPlaceholder ?? "https://...",
    btn: props.labels?.btn ?? "Inserir",
    invalidVideoError: props.labels?.invalidVideoError ?? "URL inválida.",


    widthLabel: (props.labels as any)?.widthLabel ?? "Largura do vídeo",
}));

onBeforeMount(async () => {
    titleFontStyle.value = await getFont("nobo25");

    icon.value =
        props.iconSrc ??
        "data:image/svg+xml;utf8," +
        encodeURIComponent(`
        <svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 24 24' fill='none' stroke='#2563eb' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
          <rect x='3' y='5' width='18' height='14' rx='2' ry='2'/>
          <polygon points='10 9 16 12 10 15 10 9'/>
        </svg>
      `);
});

const titleFont = computed(() => ({
    "--title-font-family": titleFontStyle.value?.["font-family"],
    "--title-font-size": titleFontStyle.value?.["font-size"],
    "--title-font-transform": titleFontStyle.value?.["text-transform"],
    "--title-font-weight": titleFontStyle.value?.["font-weight"],
}));

function isValidBasicUrl(u: string) {
    try {
        const parsed = new URL(u);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
        return false;
    }
}

function confirm() {
    const value = videoUrl.value.trim();

    if (!value) {
        isWarning.value = true;
        return;
    }

    if (!isValidBasicUrl(value) && !/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(value)) {
        isWarning.value = true;
        return;
    }

    isWarning.value = false;

    modalController.dismiss(
        { url: value, width: `${widthPercent.value}%` },
        "confirm"
    );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          _createVNode(PopUpMask, {
            style: _normalizeStyle(titleFont.value)
          }, {
            icon: _withCtx(() => [
              _createElementVNode("img", { src: icon.value }, null, 8, _hoisted_1)
            ]),
            title: _withCtx(() => [
              _createElementVNode("h2", {
                id: "title",
                style: _normalizeStyle(titleFont.value)
              }, _toDisplayString(labels.value.title), 5)
            ]),
            description: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value.lines, (line, key) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: key,
                    innerHTML: line
                  }, null, 8, _hoisted_3))
                }), 128))
              ]),
              _createVNode(MilageInput, {
                value: videoUrl.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((videoUrl).value = $event)),
                label: labels.value.videoLabel,
                placeholder: labels.value.videoPlaceholder,
                type: "text",
                "is-warning": isWarning.value
              }, null, 8, ["value", "label", "placeholder", "is-warning"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("input", {
                  type: "range",
                  min: 20,
                  max: 100,
                  step: 5,
                  value: widthPercent.value,
                  onInput: onWidthInput,
                  class: "ball-slider"
                }, null, 40, _hoisted_5),
                _createElementVNode("span", _hoisted_6, _toDisplayString(widthPercent.value) + "%", 1)
              ]),
              (isWarning.value)
                ? (_openBlock(), _createBlock(ErrorMsg, {
                    key: 0,
                    msg: labels.value.invalidVideoError
                  }, null, 8, ["msg"]))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(IonButton), {
                  height: "2.575241849rem",
                  onClick: confirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(labels.value.btn), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})